import { $translate } from '@/utils/i18n';
export const codeTableConfig = {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: $translate('lang.E3202101260047', { defaultText: '条码字符串' }),
                align: 'center',
                prop: 'barcodeNo',
                filter: true,
                require: true,
                sort: true,
                width: 200
            },
            {
                label: $translate('lang.E3202101260044', { defaultText: '产品编码' }),
                align: 'center',
                prop: 'itemCode',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202101260045', { defaultText: '产品名称' }),
                align: 'center',
                prop: 'itemName',
                filter: true,
                require: true,
                sort: true,
                width: 90
            },
            {
                label: $translate('lang.E3202101260048', { defaultText: '生产日期' }),
                align: 'center',
                prop: 'prodDate',
                filter: true,
                require: true,
                sort: true,
                width: 90
            },
            {
                label: $translate('lang.E3202101260050', { defaultText: '备注' }),
                align: 'center',
                prop: 'remark',
                filter: true,
                require: true,
                sort: true,
                width: 90
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
